import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { XpressDeliveryOrderDetail, OrderChatDto, ChatMessageType } from '@shared/models';

@Component({
	selector: 'booking-messages-tab',
	templateUrl: './booking-messages-tab.component.html',
	styleUrl: './booking-messages-tab.component.scss'
})
export class BookingMessagesTabComponent implements OnInit, OnChanges {
	@Input() deliveryOrderDetails!: XpressDeliveryOrderDetail;

	chatMessageType = ChatMessageType;
	messages: OrderChatDto[] = [];
	showChat = false;

	ngOnInit() {
		this.loadMessages();
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes['deliveryOrderDetails'] && this.deliveryOrderDetails) {
			this.loadMessages();
		}
	}


	loadMessages() {
		if (this.deliveryOrderDetails?.OrderChats) {
			this.messages = this.deliveryOrderDetails.OrderChats.sort((a, b) =>
				new Date(a.CreatedAt).getTime() - new Date(b.CreatedAt).getTime()
			);
			this.showChat = this.messages.length > 0;
		} else {
			this.messages = [];
			this.showChat = false;
		}
	}

	isRiderMessage(message: OrderChatDto): boolean {
		return message.MessageTypeId === ChatMessageType.RiderToCustomer;
	}

	isCustomerMessage(message: OrderChatDto): boolean {
		return message.MessageTypeId === ChatMessageType.CustomerToRider;
	}

	isSystemMessage(message: OrderChatDto): boolean {
		return message.MessageTypeId === ChatMessageType.SystemToCustomer ||
			   message.MessageTypeId === ChatMessageType.SystemToDriver;
	}

	getMessageSenderName(message: OrderChatDto): string {
		if (this.isRiderMessage(message)) {
			return message.RiderFullName || 'Driver';
		} else if (this.isCustomerMessage(message)) {
			return message.CustomerFullName || 'Customer';
		}
		return 'System';
	}

	trackByMessage(index: number, message: OrderChatDto): string {
		return `${message.CreatedAt}-${message.MessageTypeId}-${message.Message}`;
	}
}
